// ─── User Roles ────────────────────────────────────────────────────
export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  TENANT_ADMIN = 'TENANT_ADMIN',
  MANAGER = 'MANAGER',
  SALESPERSON = 'SALESPERSON',
  CASHIER = 'CASHIER',
  VIEWER = 'VIEWER',
}

// ─── Subscription Tiers ────────────────────────────────────────────
export type SubscriptionTier = 'FREE' | 'STARTER' | 'PROFESSIONAL' | 'ENTERPRISE';

// ─── Invoice Status ────────────────────────────────────────────────
export type InvoiceStatus = 'DRAFT' | 'PAID' | 'PARTIALLY_PAID' | 'CANCELLED';

// ─── Payment Mode ──────────────────────────────────────────────────
export type PaymentMode = 'CASH' | 'CARD' | 'UPI' | 'BANK_TRANSFER' | 'OTHER';

// ─── Unit of Measure ──────────────────────────────────────────────
export type UnitOfMeasure = 'METERS' | 'YARDS' | 'PCS' | 'KG' | 'GRAMS' | 'SETS';

// ─── Stock Movement Types ──────────────────────────────────────────
export type StockMovementType =
  | 'PURCHASE'
  | 'SALE'
  | 'RETURN'
  | 'ADJUSTMENT'
  | 'DAMAGE'
  | 'TRANSFER';

// ─── Return Status ─────────────────────────────────────────────────
export type ReturnStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'REFUNDED';

// ─── Shared API Response Wrapper ───────────────────────────────────
export interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  message?: string;
  errors?: Record<string, unknown>;
}

// ─── Pagination ────────────────────────────────────────────────────
export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: PaginationMeta;
}
